// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ::ng-deep body {
  overflow: hidden;
} */

.main {
  padding: 0 10px 20px;
}

.parent {
  background-color: white;
  padding: 0 20px;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  height: 100%;
  max-height: 850px;
  overflow: auto;
}

.questionaries {
  position: sticky;
  top: 0;
  background: white;
  height: 100%;
  min-height: 95px;
  z-index: 1;
}

.main_title {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 17px;
}

.main_title img {
  /* width: 7%; */
  border-radius: 10px;
  width: 80px;
  height: 60px;
}

.main_title span {
  color: #000000;
  margin-left: 15px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0em;
  text-align: left;
}

.node_title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 5px;
  padding: 0 50px;
}

.node_title img {
  width: 60px;
  border-radius: 10px;
  height: 40px;
}

.node_title p {
  color: #000000;
  margin-left: 15px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0em;
  text-align: left;
}

.parent_question .card {
  border-radius: 10px;
  padding: 10px;
  overflow: auto;
}

.question_chart {
  width: 25%;
  flex: 20%;
  max-width: 25%;
  padding: 0 60px 0 25px;
}

/* .questions {
  display: flex;
  gap: 2rem;
  margin: 18px 0 15px;
  padding: 0 5px;
  align-items: center;
} */

.questionForFeedback {
  display: flex;
  justify-content: space-between;
  padding: 0 5px 8px 0;
  border-bottom: 1px solid #cecece;
}

.question p {
  text-align: end;
}

.start_question {
  padding: 0 40px 0 60px;
  flex: 80%;
  max-width: 75%;
}

.question_chart .card-main {
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  padding: 15px 5px;
  /* height: 170px; */
}

.question {
  /* display: flex; */
  justify-content: space-between;
  padding: 0 5px 8px 0;
  border-bottom: 1px solid #cecece;
}

.question span:first-child,
.questionForFeedback p {
  font-size: 14px;
  font-weight: 500;
}

.forQ {
  color: #7a2df9 !important;
  padding-right: 3px !important;
}

/*.seeDetail {
  font-size: 13px;
  background-color: #f7f3ff;
  border: 1px solid #7a2df9;
  border-radius: 15px;
  width: fit-content;
  text-align: center;
  margin: 2px;
  padding: 0 5px;
  cursor: pointer;
  height: fit-content;
  text-wrap: nowrap;
}*/

.seeDetail:hover {
  color: #ffffff;
  background-color: #6438b4;
}

.seeDetail {
  font-style: normal;
  font-weight: 400 !important;
  font-size: 14px;
  border: 2px solid #6438B4;
  padding: 10px 24px;
  border-radius: 25px;
  background-color: transparent;
  color: #6438B4;
  margin: auto 5px 5px;
}

.main_answer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4%;
  margin-top: 8px;
  font-size: 13px;
}

.main_answer div {
  width: 100%;
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.ans {
  margin: 0;
  width: 100%;
  text-wrap: wrap;
  word-break: break-all !important;
}

.giveAns {
  width: 70%;
}

/* .range {
  height: 5px;
  background: #ebebeb;
  border-radius: 50px;
  margin: 0;
  width: 100%;
}
.range span {
  height: 5px;
  display: block;
  border-radius: 30px;
} */
.percentage {
  margin: 0;
  text-wrap: nowrap;
}

.question_chart span {
  display: block;
  text-align: center;
  font-size: 13px;
  /* margin-top: 12px; */
  color: #7a2df9;
  font-weight: 500;
}

/* .question_chart label {
  display: block;
  text-align: center;
  font-size: 18px;
  color: #7a2df9;
  font-weight: 500;
} */

/* .question_chart p {
  text-orientation: mixed;
  writing-mode: vertical-lr;
  text-align: center;
  font-size: 12px;
  color: #7a2df9;
  font-weight: 500;
  -webkit-transform: rotate(-180deg);
} */

.card-main canvas {
  height: 100% !important;
  width: 100% !important;
}

.card-main div {
  width: 100%;
  /* max-width: fit-content; */
  padding: 0 24px 0 0;
}

.greenCheckMark {
  width: 100%;
  max-width: 15px;
  margin: 0;
  height: 18px;
}

.greenCheckMarkForFreeform {
  width: 100%;
  max-width: 15px;
  margin: 0;
  height: 18px;
}

.greenCheckMark img,
.greenCheckMarkForFreeform img {
  width: 20px;
  vertical-align: text-bottom !important;
}

.questionnaire {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.questionnaire p {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.questionnaire p span,
.questionnaireForMobile p span {
  font-size: 14px;
  font-weight: 400;
}
.questionnaireForMobile p {
  margin: 0;
}
.questionnaire .second-paragraph {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.questionnaireForMobile {
  display: none;
}

.questionnaireForMobile p:first-child {
  display: flex;
  flex-direction: column;
}

.groupName{
  font-size: 20px;
  font-weight:500;
  padding-block: 20px;
  margin-bottom: 0;
}

.mini-sidebar-body {
  padding-left: 0px;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #afaeae;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}


.mini-sidebar-body {
  padding-left: 100px !important;
}

.group-detail{
  padding-block: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}
.group-detail img{
  object-fit: contain;
  background: #ededed;
  border-radius: 10px;
  padding: 3px;
}

.btnRefresh {
  border: none;
  color: #6c2fbb;
  font-size: 13px;
  border-radius: 4px;
  padding: 5px 10px;
  text-align: end;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: end;
  gap:4px;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
  margin-left: auto;
}

@media (max-width: 1024px) {
  .main_title img {
    /* width: 13%; */
    border-radius: 10px;
    height: 57px;
  }

  .main_title span {
    margin-left: 8px;
    /* font-size: 27px; */
  }
}

@media (min-width: 1024px) and (max-width: 1440px) {
  .cart-box .col-xl-6 {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 15px;
  }
}
@media (min-width: 1100px) and (max-width: 1440px) {
  .start_question {
    padding: 0 0 0 15px;
    flex: 70%;
    max-width: 65%;
}

.question_chart{
  width: 30%;
  flex: 30%;
  max-width: 35%;
  padding: 0 15px 0 25px;
}
}

@media (min-width: 600px) and (max-width: 1099px) {
  .start_question {
    max-width: 100%;
    padding: 0 25px;
    flex: 0;
}

.question_chart{
  max-width: 60%;
  width: 100%;
  padding: 25px 20px 0 20px;
}

.main-question{
  flex-direction: column;
}
}

@media (max-width: 575px) {
  .main_title {
    flex-direction: column;
  }
  .main_title span {
    text-align: center;
    font-size: 18px;
    margin-block: 12px;
  }
  .seeDetail-main {
    right: 10px !important;
    top: 10px;
  }
}
@media (min-width: 300px) and (max-width: 599px) {
  .start_question {
    max-width: 100%;
    padding: 0 25px;
    flex: 0;
}

.question_chart{
  max-width: 100%;
  width: 100%;
  padding: 25px 20px 0 20px;
}

.main-question{
  flex-direction: column;
}

.greenCheckMarkForFreeform {
  max-width: 15px;
}
}

@media (max-width: 425px) {
  .node_title {
    padding: 0;
    justify-content: flex-start;
  }
  .node_title p {
    margin-left: 0;
  }
  .node_title img {
    margin-right: 5px;
  }

  .start_question {
    padding: 0 15px;
  }

  .questionnaireForMobile {
    display: block;
  }

  .questionnaire {
    display: none;
  }
}

@media (min-width: 280px) and (max-width: 767px) {
  /* .main_title {
    display: flex;
    align-items: center;
    justify-content: center;
  } */

  .main_title span {
    margin-left: 8px;
    font-size: 21px;
  }

  .main_title img {
    /* width: 25%; */
    border-radius: 10px;
    height: 57px;
  }

  .node_title img {
    /* width: 22%; */
    height: 49px;
  }
  .node_title {
    font-size: 15px;
  }
  .questions {
    display: block;
  }
  .question span:first-child {
    font-size: 14px;
  }
  .parent_question {
    margin-bottom: 8%;
  }
}

@media (max-width: 320px), (width: 360px) {
  .parent {
    padding: 0 10px;
  }

  .node_title p {
    font-size: 15px;
  }
}

@media (max-width: 320px) {
  .questionForFeedback {
    flex-direction: column;
  }
  .feedbackspan {
    text-align: end;
  }
}

.seeDetail-main {
  position: absolute;
  right: 10%;
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/questionnaires-dashboard/questionnaires-dashboard.component.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;EAYE;;AAEF;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,OAAO;EACP,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;;;;;;;;GAWG;AACH;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;GAMG;;AAEH;;;;;;;;GAQG;;AAEH;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;;AAGA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,OAAO;EACP,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,cAAc;EACd,sBAAsB;AACxB;AACA;;AAEA;EACE;IACE,eAAe;IACf,eAAe;IACf,OAAO;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;AACA;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;AACA;EACE;IACE,eAAe;IACf,eAAe;IACf,OAAO;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;AACA;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;;;KAIG;;EAEH;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":["/* ::ng-deep body {\n  overflow: hidden;\n} */\n\n.main {\n  padding: 0 10px 20px;\n}\n\n.parent {\n  background-color: white;\n  padding: 0 20px;\n  border: 1px solid #e8e8e8;\n  border-radius: 12px;\n  height: 100%;\n  max-height: 850px;\n  overflow: auto;\n}\n\n.questionaries {\n  position: sticky;\n  top: 0;\n  background: white;\n  height: 100%;\n  min-height: 95px;\n  z-index: 1;\n}\n\n.main_title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 17px;\n}\n\n.main_title img {\n  /* width: 7%; */\n  border-radius: 10px;\n  width: 80px;\n  height: 60px;\n}\n\n.main_title span {\n  color: #000000;\n  margin-left: 15px;\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0em;\n  text-align: left;\n}\n\n.node_title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 0 5px;\n  padding: 0 50px;\n}\n\n.node_title img {\n  width: 60px;\n  border-radius: 10px;\n  height: 40px;\n}\n\n.node_title p {\n  color: #000000;\n  margin-left: 15px;\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0em;\n  text-align: left;\n}\n\n.parent_question .card {\n  border-radius: 10px;\n  padding: 10px;\n  overflow: auto;\n}\n\n.question_chart {\n  width: 25%;\n  flex: 20%;\n  max-width: 25%;\n  padding: 0 60px 0 25px;\n}\n\n/* .questions {\n  display: flex;\n  gap: 2rem;\n  margin: 18px 0 15px;\n  padding: 0 5px;\n  align-items: center;\n} */\n\n.questionForFeedback {\n  display: flex;\n  justify-content: space-between;\n  padding: 0 5px 8px 0;\n  border-bottom: 1px solid #cecece;\n}\n\n.question p {\n  text-align: end;\n}\n\n.start_question {\n  padding: 0 40px 0 60px;\n  flex: 80%;\n  max-width: 75%;\n}\n\n.question_chart .card-main {\n  background: #fafafa;\n  border: 1px solid #e8e8e8;\n  border-radius: 10px;\n  padding: 15px 5px;\n  /* height: 170px; */\n}\n\n.question {\n  /* display: flex; */\n  justify-content: space-between;\n  padding: 0 5px 8px 0;\n  border-bottom: 1px solid #cecece;\n}\n\n.question span:first-child,\n.questionForFeedback p {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.forQ {\n  color: #7a2df9 !important;\n  padding-right: 3px !important;\n}\n\n/*.seeDetail {\n  font-size: 13px;\n  background-color: #f7f3ff;\n  border: 1px solid #7a2df9;\n  border-radius: 15px;\n  width: fit-content;\n  text-align: center;\n  margin: 2px;\n  padding: 0 5px;\n  cursor: pointer;\n  height: fit-content;\n  text-wrap: nowrap;\n}*/\n\n.seeDetail:hover {\n  color: #ffffff;\n  background-color: #6438b4;\n}\n\n.seeDetail {\n  font-style: normal;\n  font-weight: 400 !important;\n  font-size: 14px;\n  border: 2px solid #6438B4;\n  padding: 10px 24px;\n  border-radius: 25px;\n  background-color: transparent;\n  color: #6438B4;\n  margin: auto 5px 5px;\n}\n\n.main_answer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4%;\n  margin-top: 8px;\n  font-size: 13px;\n}\n\n.main_answer div {\n  width: 100%;\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n}\n\n.ans {\n  margin: 0;\n  width: 100%;\n  text-wrap: wrap;\n  word-break: break-all !important;\n}\n\n.giveAns {\n  width: 70%;\n}\n\n/* .range {\n  height: 5px;\n  background: #ebebeb;\n  border-radius: 50px;\n  margin: 0;\n  width: 100%;\n}\n.range span {\n  height: 5px;\n  display: block;\n  border-radius: 30px;\n} */\n.percentage {\n  margin: 0;\n  text-wrap: nowrap;\n}\n\n.question_chart span {\n  display: block;\n  text-align: center;\n  font-size: 13px;\n  /* margin-top: 12px; */\n  color: #7a2df9;\n  font-weight: 500;\n}\n\n/* .question_chart label {\n  display: block;\n  text-align: center;\n  font-size: 18px;\n  color: #7a2df9;\n  font-weight: 500;\n} */\n\n/* .question_chart p {\n  text-orientation: mixed;\n  writing-mode: vertical-lr;\n  text-align: center;\n  font-size: 12px;\n  color: #7a2df9;\n  font-weight: 500;\n  -webkit-transform: rotate(-180deg);\n} */\n\n.card-main canvas {\n  height: 100% !important;\n  width: 100% !important;\n}\n\n.card-main div {\n  width: 100%;\n  /* max-width: fit-content; */\n  padding: 0 24px 0 0;\n}\n\n.greenCheckMark {\n  width: 100%;\n  max-width: 15px;\n  margin: 0;\n  height: 18px;\n}\n\n.greenCheckMarkForFreeform {\n  width: 100%;\n  max-width: 15px;\n  margin: 0;\n  height: 18px;\n}\n\n.greenCheckMark img,\n.greenCheckMarkForFreeform img {\n  width: 20px;\n  vertical-align: text-bottom !important;\n}\n\n.questionnaire {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n}\n\n.questionnaire p {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.questionnaire p span,\n.questionnaireForMobile p span {\n  font-size: 14px;\n  font-weight: 400;\n}\n.questionnaireForMobile p {\n  margin: 0;\n}\n.questionnaire .second-paragraph {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.questionnaireForMobile {\n  display: none;\n}\n\n.questionnaireForMobile p:first-child {\n  display: flex;\n  flex-direction: column;\n}\n\n.groupName{\n  font-size: 20px;\n  font-weight:500;\n  padding-block: 20px;\n  margin-bottom: 0;\n}\n\n.mini-sidebar-body {\n  padding-left: 0px;\n}\n\n/* width */\n::-webkit-scrollbar {\n  width: 5px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #afaeae;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n\n.mini-sidebar-body {\n  padding-left: 100px !important;\n}\n\n.group-detail{\n  padding-block: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n}\n.group-detail img{\n  object-fit: contain;\n  background: #ededed;\n  border-radius: 10px;\n  padding: 3px;\n}\n\n.btnRefresh {\n  border: none;\n  color: #6c2fbb;\n  font-size: 13px;\n  border-radius: 4px;\n  padding: 5px 10px;\n  text-align: end;\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  gap:4px;\n  cursor: pointer;\n  width: fit-content;\n  margin-left: auto;\n}\n\n@media (max-width: 1024px) {\n  .main_title img {\n    /* width: 13%; */\n    border-radius: 10px;\n    height: 57px;\n  }\n\n  .main_title span {\n    margin-left: 8px;\n    /* font-size: 27px; */\n  }\n}\n\n@media (min-width: 1024px) and (max-width: 1440px) {\n  .cart-box .col-xl-6 {\n    flex: 0 0 100%;\n    max-width: 100%;\n    margin-bottom: 15px;\n  }\n}\n@media (min-width: 1100px) and (max-width: 1440px) {\n  .start_question {\n    padding: 0 0 0 15px;\n    flex: 70%;\n    max-width: 65%;\n}\n\n.question_chart{\n  width: 30%;\n  flex: 30%;\n  max-width: 35%;\n  padding: 0 15px 0 25px;\n}\n}\n\n@media (min-width: 600px) and (max-width: 1099px) {\n  .start_question {\n    max-width: 100%;\n    padding: 0 25px;\n    flex: 0;\n}\n\n.question_chart{\n  max-width: 60%;\n  width: 100%;\n  padding: 25px 20px 0 20px;\n}\n\n.main-question{\n  flex-direction: column;\n}\n}\n\n@media (max-width: 575px) {\n  .main_title {\n    flex-direction: column;\n  }\n  .main_title span {\n    text-align: center;\n    font-size: 18px;\n    margin-block: 12px;\n  }\n  .seeDetail-main {\n    right: 10px !important;\n    top: 10px;\n  }\n}\n@media (min-width: 300px) and (max-width: 599px) {\n  .start_question {\n    max-width: 100%;\n    padding: 0 25px;\n    flex: 0;\n}\n\n.question_chart{\n  max-width: 100%;\n  width: 100%;\n  padding: 25px 20px 0 20px;\n}\n\n.main-question{\n  flex-direction: column;\n}\n\n.greenCheckMarkForFreeform {\n  max-width: 15px;\n}\n}\n\n@media (max-width: 425px) {\n  .node_title {\n    padding: 0;\n    justify-content: flex-start;\n  }\n  .node_title p {\n    margin-left: 0;\n  }\n  .node_title img {\n    margin-right: 5px;\n  }\n\n  .start_question {\n    padding: 0 15px;\n  }\n\n  .questionnaireForMobile {\n    display: block;\n  }\n\n  .questionnaire {\n    display: none;\n  }\n}\n\n@media (min-width: 280px) and (max-width: 767px) {\n  /* .main_title {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  } */\n\n  .main_title span {\n    margin-left: 8px;\n    font-size: 21px;\n  }\n\n  .main_title img {\n    /* width: 25%; */\n    border-radius: 10px;\n    height: 57px;\n  }\n\n  .node_title img {\n    /* width: 22%; */\n    height: 49px;\n  }\n  .node_title {\n    font-size: 15px;\n  }\n  .questions {\n    display: block;\n  }\n  .question span:first-child {\n    font-size: 14px;\n  }\n  .parent_question {\n    margin-bottom: 8%;\n  }\n}\n\n@media (max-width: 320px), (width: 360px) {\n  .parent {\n    padding: 0 10px;\n  }\n\n  .node_title p {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 320px) {\n  .questionForFeedback {\n    flex-direction: column;\n  }\n  .feedbackspan {\n    text-align: end;\n  }\n}\n\n.seeDetail-main {\n  position: absolute;\n  right: 10%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
